import { QRCodeCanvas } from 'qrcode.react'
import { useT } from '../i18n'
import { publicOrigin } from '../lib/api/tv'

/**
 * Scannable QR for joining a room. Encodes the public join URL so a
 * guest can point their camera at the host's screen instead of typing
 * a code. The QR naturally "expires" with the room — once the room is
 * gone the URL just lands on a "room not found" screen.
 */
export function RoomQR({ code, size = 128, path = 'join' }: {
  code: string; size?: number
  /** Route the scan lands on. Defaults to the shared /join resolver. */
  path?: string
}) {
  const t = useT()
  const url = `${publicOrigin()}/${path}/${code}`
  return (
    <div className="inline-flex flex-col items-center gap-2 bg-white p-3 rounded-2xl shadow-card border border-brand-border">
      <QRCodeCanvas value={url} size={size} bgColor="#ffffff" fgColor="#111111" />
      <p className="text-sm font-bold tracking-[0.25em] text-brand-text">{code}</p>
      <p className="text-[10px] text-brand-muted -mt-1">{t('Scan to join')}</p>
    </div>
  )
}
